import api from 'api'
import { fetchWithToken } from 'utils'

/**
 * Retrieves the Pbx id using the lmiAccountKey
 */
const fetchPbxId = async (lmiAccountKey: string): Promise<string | null> => {
  const route = `pbxs/${lmiAccountKey}`

  return fetchWithToken({
    method: 'GET',
    resource: api.pbx,
    path: route,
  })
    .then((response: Response) => {
      if (response.status === 200) {
        return response.json()
      } else {
        return ''
      }
    })
    .then((payload) => payload?.jrn?.split(':')[4] || '')
    .catch((err: Error) => {
      // Something wrong happened during the fetch
      console.log(err.toString())
      return ''
    })
}

export default fetchPbxId
